import { useEffect } from "react";
import { useMachine } from "@xstate/react";
import { fetchMachine, FetchEventType } from "machines/fetchMachine";
import { getBookMetaSelection } from "api/bookMeta/index";
import { setSelectOptions } from "utils/common";
import { EDUCATIONAL_LIST } from "constants/index";
import { getBasicTableData } from "api/definition/index";
import { getChapterBooksRelated } from "api/chapter/index";

const useOptions = (selectedYear, selectedEduSubject) => {
	const [stateBookMetaSelection, sendBookMetaSelection] = useMachine(fetchMachine, {
		services: {
			fetchData: async () => {
				const { data } = await getBookMetaSelection();
				const { yearMap, eduSubject } = data;
				return {
					yearOptions: setSelectOptions(yearMap),
					eduSubjectOptions: setSelectOptions(
						Object.entries(eduSubject).flatMap(([edu, subjects]) =>
							subjects.map((subject) => ({
								code: edu + subject.code,
								name: `${EDUCATIONAL_LIST[edu]} ${subject.name}`,
							})),
						),
					),
				};
			},
		},
	});
	const { yearOptions, eduSubjectOptions } = stateBookMetaSelection.context.result || {};
	const [stateBasicTableData, sendBasicTableData] = useMachine(fetchMachine, {
		services: {
			fetchData: async () => {
				const { data } = await getBasicTableData();
				return {
					versionOptions: data.data["PUBLISHER"].map((item) => ({
						name: item.name,
						value: item.code,
					})),
				};
			},
		},
	});
	const { versionOptions } = stateBasicTableData.context.result || {};
	const [stateBooks, sendBooks] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_ctx, event) => {
				const { data } = await getChapterBooksRelated(event.year, event.payload);
				return {
					bookOptions: setSelectOptions(data?.bookMap),
				};
			},
		},
	});
	const { bookOptions } = stateBooks.context.result || {};

	useEffect(() => {
		sendBookMetaSelection(FetchEventType.Fetch);
		sendBasicTableData(FetchEventType.Fetch);
	}, []);

	useEffect(() => {
		const selectedEdu = selectedEduSubject?.slice(0, 1);
		const selectedSubject = selectedEduSubject?.slice(1);
		if (!selectedYear || !selectedEdu || !selectedSubject) return;
		sendBooks(FetchEventType.Fetch, {
			year: selectedYear,
			payload: {
				edu: selectedEdu,
				subject: selectedSubject,
			},
		});
	}, [selectedYear, selectedEduSubject]);

	return {
		yearOptions,
		eduSubjectOptions,
		versionOptions,
		bookOptions,
	};
};

export default useOptions;
